export const ITALIAN_REGIONS = [
  { code: 'ABR', name: 'Abruzzo' },
  { code: 'BAS', name: 'Basilicata' },
  { code: 'CAL', name: 'Calabria' },
  { code: 'CAM', name: 'Campania' },
  { code: 'EMR', name: 'Emilia-Romagna' },
  { code: 'FVG', name: 'Friuli-Venezia Giulia' },
  { code: 'LAZ', name: 'Lazio' },
  { code: 'LIG', name: 'Liguria' },
  { code: 'LOM', name: 'Lombardia' },
  { code: 'MAR', name: 'Marche' },
  { code: 'MOL', name: 'Molise' },
  { code: 'PIE', name: 'Piemonte' },
  { code: 'PUG', name: 'Puglia' },
  { code: 'SAR', name: 'Sardegna' },
  { code: 'SIC', name: 'Sicilia' },
  { code: 'TOS', name: 'Toscana' },
  { code: 'TAA', name: 'Trentino-Alto Adige' },
  { code: 'UMB', name: 'Umbria' },
  { code: 'VDA', name: "Valle d'Aosta" },
  { code: 'VEN', name: 'Veneto' },
] as const;

export const MONTHS = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre',
] as const;

export type RegionCode = typeof ITALIAN_REGIONS[number]['code'];
export type ThresholdInputs = Record<RegionCode, string>;

export function territorialPeriodId(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, '0')}`;
}

export function emptyThresholdInputs(): ThresholdInputs {
  return Object.fromEntries(ITALIAN_REGIONS.map(({ code }) => [code, ''])) as ThresholdInputs;
}

export function thresholdInputIsValid(value: string): boolean {
  return /^\d*(?:[.,]\d*)?$/.test(value.trim());
}

export function parseThreshold(value: string): number | null {
  const normalized = value.trim().replace(',', '.');
  if (!normalized) return null;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
}

export function storedThresholdsToInputs(value: unknown): ThresholdInputs {
  const inputs = emptyThresholdInputs();
  if (!value || typeof value !== 'object') return inputs;

  for (const { code } of ITALIAN_REGIONS) {
    const threshold = (value as Record<string, unknown>)[code];
    if (typeof threshold === 'number' && Number.isFinite(threshold) && threshold >= 0) {
      inputs[code] = String(threshold).replace('.', ',');
    }
  }

  return inputs;
}
